/**
 * Formatta la data dal formato inglese a quello italiano
 * @method formatDateEnToIT
 * @param date
 * @returns {string}
 */
function formatDateEnToIT(date) {
  if (date) {
    let formattedDate = moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY");
    formattedDate += ` <small>- ${moment(date, "YYYY-MM-DD HH:mm:ss").format("HH:mm")}</small>`

    return formattedDate;
  }

  return "-";
}

/**
 * Formatta la data dal formato inglese a quello italiano senza l'ora
 * @param date
 * @returns {string}
 */
function formatDate(date) {
  if (date) {
    return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY");
  }
  return "-";
}

/**
 * Ripulisce il name dei filtri presi dall'url dai separatori
 * @method cleanFilterName
 * @param name
 * @returns {string}
 */
function cleanFilterName(name) {
  let filterName = name.replaceAll("-", " ");
  filterName = filterName.substring(1);
  return filterName.replaceAll("|", " | ");
}

/**
 * Genera un random ID
 * @method generateID
 * @param prefix
 * @param size
 * @returns {string}
 */
function generateID(prefix, size = 5) {
  let hash = Math.random().toString(36).substring(2, size) + Math.random().toString(36).substring(2, size);
  return prefix + "-" + hash;
}

/**
 * Formatta il codice identificativo della pratica
 * @method codicePratica
 * @param codice
 * @param anno
 * @param natura_atto
 * @param descrizione
 * @param praticaLink
 * @returns {string}
 */
function codicePratica(codice, anno, natura_atto, descrizione, praticaLink = null) {
  let annoAtto = (anno) ? "-" + anno.toString().substring(2, 4) : "";
  let descrizionePratica = descrizione ? "<p class=\"crm:text-secondary\">" + descrizione + "</p>" : "";
  let codicePratica = "(<span>" + codice + annoAtto + "</span>)";
  if (praticaLink) {
    codicePratica = "<a href=\"" + praticaLink + "\" class=\"crm:text-primary! crm:underline!\" title=\"Vai alla pratica\">" + codicePratica + "</a>";
  }
  return codicePratica + " " + natura_atto + descrizionePratica;
}

export { formatDateEnToIT, formatDate, cleanFilterName, generateID, codicePratica };